import { PlatformPage } from './PlatformPage'
import { ContactMessagesTab } from './tabs/ContactMessagesTab'

export function ContactMessagesPage() {
  return (
    <PlatformPage
      title="Contact Messages"
      description="Customer-submitted sales inquiries, bug reports, feature requests, and support questions."
    >
      <ContactMessagesTab />
    </PlatformPage>
  )
}
